export default __webpack_public_path__ + "static/media/SA_Templates_M1.f1f0fed3.pdf";